/**
 * Enum Trạng thái bản ghi phục hồi
 * nmtuan4 8.3.2023
 */
export default {
  Success: 1, // phục hồi thành công
  WaitingBackup: 2, // đang phục hồi
  Error: 3, // phục hồi thất bại
  Expiration: 4, // quá hạn
  // CancelBackup: 5, // đang bấm hủy phục hồi
  WaitingRestore: 6, // đang phục hồi
  // CancelRestore: 7, // đang bấm hủy phục hồi
};
